/** Custom errors for the dashboard app — never throw a bare `Error`. */

/** Thrown when the HTML mount point the SPA renders into is missing. */
export class MountPointNotFoundError extends Error {
  readonly code = "MOUNT_POINT_NOT_FOUND" as const;
  constructor(selector: string) {
    super(`missing mount point: ${selector}`);
    this.name = "MountPointNotFoundError";
  }
}

/** Thrown when a hook that needs auth context is used outside its provider. */
export class AuthContextMissingError extends Error {
  readonly code = "AUTH_CONTEXT_MISSING" as const;
  constructor() {
    super("useAuth must be used inside <AuthProvider>");
    this.name = "AuthContextMissingError";
  }
}
